<uni-text-caption class="nav-text">
  <ng-content></ng-content>
</uni-text-caption>
